import styled from 'styled-components'

export const PreviewTitleWrapper = styled.div`
    margin-left: ${props => props.theme.spacing.medium};
`
